<!-- 列表页表格 -->
<template>
    <div class="chartWrap">
        <Echarts :options="options"></Echarts>
    </div>
</template>

<script>
import Echarts from "@/components/Echarts";
import Util from '@/utils/Util';
import chartsConfig from "../config/chartsConfig";
export default {
    data() {
        return {
            dpr:Util.setDpr(),
            options:{},
        }
    },
    components: {
        Echarts,
    },
    props:{
        chartData:{
            type:Object,
            default(){
                return {};
            }
        },
    },
    mounted() {
        this.initOpt()
        this.$UtilTool.dispatchDefine()
    },
    methods: {
        initOpt(){
            let chartType = this.chartData.chartType;//图表类型

            let obj = {
                chartType:this.chartData.chartType,
                title:this.chartData.title,
                chartData:this.chartData.chartData
            };

            /**
             * chartType=="line_bar"||"bar"||"stackbar"||"stackbar_Horizontal"
             * 统一都使用 basebar 的参数设置
             */
            if(chartType.indexOf('bar')!=-1){
                chartType='basebar'
            }

            switch(chartType){
                case "pie":
                    obj.unit=this.chartData.unit
                    break;
                case "basebar":
                    obj.xAxisData=this.chartData.xAxisData
                    break;
            }

            let config=chartsConfig[chartType](obj)
            this.$nextTick(() => {
                this.options=config.option
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.chartWrap{
    width:100%;
    height: 3.8rem;
}
</style>
